import $ from "jquery";
import {
    handleEnterKeyPress,
    addCustomTargetBtnHandler,
    togglePillContainer,
    removeCustomTargetBtnHandler,
} from "@ts/bulk-keywords-addition";
import { KeyboardEvent } from "react";
import { FaMinus, FaPlus, FaTimes } from "react-icons/fa";

interface IAddTargets {
    removeTargetsDisplay: string;
    setRemoveTargetsDisplay: (removeTargetsDisplay: string) => void;
    resetAll: () => void;
}

const AddTargets: React.FC<IAddTargets> = ({
    removeTargetsDisplay,
    setRemoveTargetsDisplay,
    resetAll,
}) => {
    const closeCustomPillContainer = () => {
        window.sessionStorage.removeItem("unsavedSelectedData");
        togglePillContainer();
        $("#add-custom-targets").hide();
        setRemoveTargetsDisplay("none");
        document.getElementsByClassName("pillBody")[0].innerHTML = "";
    };

    const resetProcesses = () => {
        const isFilterEmpty =
            document.getElementsByClassName("pillBody")[0].innerHTML === "";
        if (isFilterEmpty) {
            resetAll();
        }
    };

    return (
        <>
            <div className="pb-3 ps-3">
                <div className="d-flex align-center">
                    <div className="me-1">
                        <button
                            className="btn btn-sm btn-danger ms-1 mt-1"
                            id="remove-custom-targets"
                            type="button"
                            data-toggle="tooltip"
                            title="Remove custom targets"
                            onClick={() => {
                                resetProcesses();
                                removeCustomTargetBtnHandler();
                            }}
                            style={{ display: `${removeTargetsDisplay}` }}
                        >
                            <FaMinus className="fw-bolder"/>
                        </button>

                        <button
                            className="btn btn-sm btn-success ms-1 mt-1"
                            id="addKwdBtn"
                            type="button"
                            data-bs-toggle="tooltip"
                            title="Add custom targets"
                            onClick={() => {
                                togglePillContainer();
                            }}
                        >
                            <FaPlus style={{transform: "translateY(-10%)"}} className="fw-bolder"/>
                        </button>
                    </div>
                    <div className="selectedKeywords" style={{
                        maxHeight:"5rem",
                        overflowY:"auto"
                    }}></div>
                </div>

                <div className="pillContainer">
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                    >
                        <div className="pillBody" />
                        <textarea
                            id="target-pill-input"
                            onKeyPress={(
                                event: KeyboardEvent<HTMLTextAreaElement>
                            ) => {
                                handleEnterKeyPress(event);
                            }}
                            placeholder="Type custom targets and press enter after each targets"
                        />
                        <button
                            className="btn btn-sm btn-success mt-2"
                            type="button"
                            id="add-custom-targets"
                            style={{ display: "none" }}
                            onClick={() => {
                                addCustomTargetBtnHandler();
                                setRemoveTargetsDisplay("unset");
                            }}
                        >
                            Add custom targets
                        </button>
                    </div>
                    <FaTimes className="text-dark" style={{
                            cursor: "pointer",
                            fontSize: "1rem",
                        }}
                        onClick={closeCustomPillContainer}/>
                </div>
            </div>
        </>
    );
};

export default AddTargets;
